<template>
  <div class="loader-overlay" :class="{'fixed': fixed}" v-if="loading" @touchmove="prevent">
    <div class="loader"></div>
  </div>
</template>

<script>

export default {
  name: 'loader',
  data () {
    return {}
  },
  props: {
    loading: Boolean,
    fixed: {
      type: Boolean,
      default: true
    }
  },
  components: {
  },
  computed: {

  },
  methods: {
    prevent (event) {
      event.preventDefault()
      event.stopPropagation()
    }
  },
  beforeDestroy () {
    document.documentElement.style.overflow = ''
  },
  watch: {
    loading: function (val) {
      document.documentElement.style.overflow = val ? 'hidden' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.loader-overlay{
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $white;
  @include opacity(.6);
  // pointer-events: none;

  &.fixed{
    position: fixed;
  }

  .loader{
    border-width: 3px;
    height: 3em;
    width: 3em;
  }
}
</style>
